var _rect, _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTodoListArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 126,
    viewBox: "0 0 107 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 126,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-7330 -1570C-7330 -1645.11 -7269.11 -1706 -7194 -1706H12654C12729.1 -1706 12790 -1645.11 12790 -1570V2853C12790 2928.11 12729.1 2989 12654 2989H-7194C-7269.11 2989 -7330 2928.11 -7330 2853V-1570Z",
    fill: "#F5FBF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-7194 -1700H12654V-1712H-7194V-1700ZM12784 -1570V2853H12796V-1570H12784ZM12654 2983H-7194V2995H12654V2983ZM-7324 2853V-1570H-7336V2853H-7324ZM-7194 2983C-7265.8 2983 -7324 2924.8 -7324 2853H-7336C-7336 2931.42 -7272.42 2995 -7194 2995V2983ZM12784 2853C12784 2924.8 12725.8 2983 12654 2983V2995C12732.4 2995 12796 2931.42 12796 2853H12784ZM12654 -1700C12725.8 -1700 12784 -1641.8 12784 -1570H12796C12796 -1648.42 12732.4 -1712 12654 -1712V-1700ZM-7194 -1712C-7272.42 -1712 -7336 -1648.42 -7336 -1570H-7324C-7324 -1641.8 -7265.8 -1700 -7194 -1700V-1712Z",
    fill: "#ACC0BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-823 -1173C-823 -1228.23 -778.228 -1273 -723 -1273H1018C1073.23 -1273 1118 -1228.23 1118 -1173V1121C1118 1176.23 1073.23 1221 1018 1221H-723C-778.229 1221 -823 1176.23 -823 1121V-1173Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-723 -1268H1018V-1278H-723V-1268ZM1113 -1173V1121H1123V-1173H1113ZM1018 1216H-723V1226H1018V1216ZM-818 1121V-1173H-828V1121H-818ZM-723 1216C-775.467 1216 -818 1173.47 -818 1121H-828C-828 1178.99 -780.99 1226 -723 1226V1216ZM1113 1121C1113 1173.47 1070.47 1216 1018 1216V1226C1075.99 1226 1123 1178.99 1123 1121H1113ZM1018 -1268C1070.47 -1268 1113 -1225.47 1113 -1173H1123C1123 -1230.99 1075.99 -1278 1018 -1278V-1268ZM-723 -1278C-780.99 -1278 -828 -1230.99 -828 -1173H-818C-818 -1225.47 -775.467 -1268 -723 -1268V-1278Z",
    fill: "#ACC0BA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-723 -1141C-723 -1158.67 -708.673 -1173 -691 -1173H525C542.673 -1173 557 -1158.67 557 -1141V1089C557 1106.67 542.673 1121 525 1121H-691C-708.673 1121 -723 1106.67 -723 1089V-1141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-723 -1141C-723 -1158.67 -708.673 -1173 -691 -1173H525C542.673 -1173 557 -1158.67 557 -1141V1089C557 1106.67 542.673 1121 525 1121H-691C-708.673 1121 -723 1106.67 -723 1089V-1141Z",
    fill: "url(#paint0_linear_1_36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-304 -138.204C-304 -155.877 -289.673 -170.204 -272 -170.204H485C502.673 -170.204 517 -155.877 517 -138.204V294.796C517 312.469 502.673 326.796 485 326.796H-272C-289.673 326.796 -304 312.469 -304 294.796V-138.204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.935303 35.532C0.935303 31.2595 4.39888 27.7959 8.67141 27.7959H77.0702C81.3427 27.7959 84.8063 31.2595 84.8063 35.532V117.64C84.8063 121.913 81.3427 125.377 77.0702 125.377H8.67142C4.39888 125.377 0.935303 121.913 0.935303 117.64V35.532Z",
    fill: "#E9EDF4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4153,
    y: 63.0879,
    width: 36.4241,
    height: 4.19039,
    rx: 1.28935,
    fill: "#284993"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.4968,
    y: 42.1367,
    width: 63.8228,
    height: 9.02545,
    rx: 1.28935,
    fill: "#007580"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7705,
    y: 105.638,
    width: 21.2743,
    height: 4.19039,
    rx: 1.28935,
    fill: "#284993"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4153,
    y: 77.2705,
    width: 36.4241,
    height: 4.19039,
    rx: 1.28935,
    fill: "#284993"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4153,
    y: 91.4541,
    width: 36.4241,
    height: 4.19039,
    rx: 1.28935,
    fill: "#007580"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 17.4596,
    y: 60.9933,
    width: 8.38078,
    height: 8.38078,
    rx: 0.483507,
    stroke: "#284993",
    strokeWidth: 0.967014
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 17.4596,
    y: 76.1427,
    width: 8.38078,
    height: 8.38078,
    rx: 0.483507,
    stroke: "#284993",
    strokeWidth: 0.967014
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 17.4596,
    y: 89.3595,
    width: 8.38078,
    height: 8.38078,
    rx: 0.483507,
    stroke: "#284993",
    strokeWidth: 0.967014
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8386 64.4909C21.5368 64.134 21.0029 64.0893 20.646 64.3911C20.2891 64.6928 20.2444 65.2267 20.5461 65.5836L22.8681 68.3301C23.1699 68.687 23.7038 68.7317 24.0607 68.43C24.4176 68.1282 24.4623 67.5943 24.1606 67.2374L21.8386 64.4909Z",
    fill: "#284993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5977 61.4893L28.6466 61.5382C29.2805 62.1721 29.2805 63.1999 28.6466 63.8338L24.0928 68.3876C23.7623 68.7181 23.2265 68.7181 22.8961 68.3876C22.5656 68.0571 22.5656 67.5213 22.8961 67.1908L28.5977 61.4893Z",
    fill: "#284993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8383 78.6736C21.5366 78.3167 21.0027 78.272 20.6458 78.5737C20.2889 78.8754 20.2442 79.4094 20.5459 79.7663L22.8679 82.5127C23.1696 82.8696 23.7035 82.9143 24.0604 82.6126C24.4173 82.3108 24.4621 81.7769 24.1603 81.42L21.8383 78.6736Z",
    fill: "#284993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5977 75.6738L28.6466 75.7227C29.2805 76.3567 29.2805 77.3845 28.6466 78.0184L24.0928 82.5722C23.7623 82.9026 23.2265 82.9026 22.8961 82.5722C22.5656 82.2417 22.5656 81.7059 22.8961 81.3754L28.5977 75.6738Z",
    fill: "#284993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0266 93.2336C65.9593 93.5196 64.9826 92.543 65.2686 91.4757L75.5782 52.9996C75.8642 51.9323 77.1984 51.5748 77.9797 52.3562L106.146 80.5226C106.927 81.3039 106.57 82.638 105.503 82.924L67.0266 93.2336Z",
    fill: "#FF7F50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.5552,
    y: 75.585,
    width: 10.8023,
    height: 22.173,
    rx: 1.43539,
    transform: "rotate(-135 90.5552 75.585)",
    fill: "#FF7F50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_36",
    x1: -83,
    y1: -1173,
    x2: -83,
    y2: 262.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F7FB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-723 -1141C-723 -1158.67 -708.673 -1173 -691 -1173H525C542.673 -1173 557 -1158.67 557 -1141V1089C557 1106.67 542.673 1121 525 1121H-691C-708.673 1121 -723 1106.67 -723 1089V-1141Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodoListArrow);
export default __webpack_public_path__ + "static/media/TodoListArrow.c7b356302daf553d94c4d57e57fe2156.svg";
export { ForwardRef as ReactComponent };